/** The size of Karo's gate collage on her board (photo frame and cards). */
export const COLLAGE_WIDTH = 448;
export const COLLAGE_HEIGHT = 300;
/** How far the project card reaches past the photo's right edge (`right: -25px`). */
export const COLLAGE_OVERHANG = 25;

/**
 * The factor the collage is drawn at to fit `available` pixels: smaller where
 * there is not room for the board's size, larger in a wider column up to
 * `maxScale` (by default never larger than the board).
 */
export function getCollageScale({
  available,
  fitWidth,
  maxScale = 1,
}: {
  available: number;
  fitWidth: number;
  maxScale?: number;
}): number {
  return Math.min(maxScale, Math.max(0, available / fitWidth));
}
